import { createReducer, on, State, Action, Store } from '@ngrx/store';
import { IUser } from '@shared/interfaces/user.interface';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
  LOGIN_REQUEST_FAILED,
} from '@store/actions';

import { Storage } from '@capacitor/storage';

export interface authState {
  user: IUser;
  isLogged: boolean;
  isLoading: boolean;
  isLoginFailed: boolean;
  token: string;
  error: any;
}

export const authInitialState: authState = {
  user: null,
  isLogged: false,
  isLoading: false,
  isLoginFailed: false,
  token: null,
  error: null,
};

const _AuthReducer = createReducer(
  authInitialState,

  on(LOGIN_REQUEST, (state) => ({
    ...state,
    isLoading: true,
    isLoginFailed: false,
  })),

  on(LOGIN_SUCCESS, (state, { user, token }) => {
    if (!token) {
      token = '';
      Storage.clear();
    }

    Storage.set({ key: 'token', value: token });
    Storage.set({ key: 'user', value: JSON.stringify(user) });
    return {
      ...state,
      isLogged: true,
      isLoading: false,
      isLoginFailed: false,
      token,
      user: { ...user },
    };
  }),

  on(LOGIN_FAILED, (state) => ({
    ...state,
    isLoading: false,
    isLogged: false,
    isLoginFailed: true,
  })),

  on(LOGOUT_SUCCESS, (state) => {
    Storage.clear();
    return {
      ...state,
      isLogged: false,
      isLoading: false,
      isLoginFailed: false,
      token: null,
      user: null,
    };
  }),

  on(LOGIN_REQUEST_FAILED, (state, { payload }) => ({
    ...state,
    isLogged: false,
    isLoading: false,
    isLoginFailed: false,
    token: null,
    error: payload,
  })),
);

export function AuthReducer(state: authState, action: Action) {
  return _AuthReducer(state, action);
}
//TODO: comentar
